require('./mortgageRequestHolderConfirmationView.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
// @ components
const { MortgageRequestHolderConfirmation } = require('components/mortgageRequest/mortgageRequestHolderConfirmation/mortgageRequestHolderConfirmation');

class MortgageRequestHolderConfirmationView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { match: { params: { holderId } }, immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const breadCrumbData = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestHolderConfirmation-breadcrumbText'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        const headerTitle = isClientWithoutAccounts
            ? 'mortgageRequestHolderConfirmation-titleHeader'
            : 'mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_clientTitleHeader'

        return (
            <div className="mortgage-request-holder-confirmation-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={breadCrumbData}
                                finalTitle={getFinalTitle(headerTitle)}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <MortgageRequestHolderConfirmation holderId={holderId} isClientWithoutAccounts={isClientWithoutAccounts} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestHolderConfirmationView.propTypes = {
    match: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
};

module.exports.MortgageRequestHolderConfirmationView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageRequestHolderConfirmationView);
